module.exports = __webpack_public_path__ + "static/media/theo.21a60ecc.png";